export const header = {
  headerInfo: {
    customerNumber: 'Customer number: {{b2bUnitId}}'
  }
};
